import React from "react";
import { Button, TextField } from "@mui/material";
import Abhaicons from "../../Images/Adharicon.svg";
import Abhashiled from "../../Images/material-symbols-light_shield-outline.svg";
import { formatAbhaId } from "../../../helpers/commonHelper";

const Step4AbhaRegistered = ({ abhaData, onRegisterBeneficiary }) => {
    const constructDob = (abhaProfile) => {
        // Construct from separate fields (new format)
        const day = abhaData?.dayOfBirth;
        const month = abhaData?.monthOfBirth;
        const year = abhaData?.yearOfBirth;

        if (day && month && year) {
            // Ensure day and month are zero-padded
            const paddedDay = String(day).padStart(2, '0');
            const paddedMonth = String(month).padStart(2, '0');
            return `${year}-${paddedMonth}-${paddedDay}`;
        }

        return "";
    };

    // Get full name
    const getFullName = () => {
        if (!abhaData) return "";
        const { firstName, middleName, lastName } = abhaData;
        return [firstName, middleName, lastName].filter(Boolean).join(" ");
    };

    // Get gender display
    const getGender = () => {
        if (!abhaData?.gender) return "";
        return abhaData.gender === "M" ? "Male" : abhaData.gender === "F" ? "Female" : "Other";
    };

    return (
        <div className="text-center">
            <img src={Abhaicons} alt="ABHA Icon" />
            <h5 className="sub-text">ABHA Registered</h5>
            <p className="sub-para">
                Complete your ABHA profile with additional information
            </p>

            <div className="container-fluid abha-form">
                <div className="row g-3">
                    {/* Full Name */}
                    <div className="col-md-6">
                        <TextField
                            label="Full Name"
                            variant="outlined"
                            fullWidth
                            size="small"
                            value={getFullName()}
                            disabled
                        />
                    </div>

                    {/* Date of Birth */}
                    <div className="col-md-6">
                        <TextField
                            label="Date of Birth"
                            type="date"
                            variant="outlined"
                            fullWidth
                            size="small"
                            value={constructDob(abhaData)}
                            InputLabelProps={{ shrink: true }}
                            disabled
                        />
                    </div>
                </div>

                <div className="row g-3 mt-1">
                    {/* Gender Dropdown */}
                    <div className="col-md-6">
                        <TextField
                            select
                            label="Gender"
                            variant="outlined"
                            fullWidth
                            size="small"
                            value={getGender()}
                            SelectProps={{ native: true }}
                            disabled
                        >
                            <option value="">Select Gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Other">Other</option>
                        </TextField>
                    </div>

                    {/* Mobile Number */}
                    <div className="col-md-6">
                        <TextField
                            label="Mobile Number"
                            variant="outlined"
                            fullWidth
                            size="small"
                            value={abhaData?.mobile || ""}
                            disabled
                        />
                    </div>
                </div>

                <div className="row g-3 mt-1">
                    {/* ABHA Number */}
                    <div className="col-md-6">
                        <TextField
                            label="ABHA Number"
                            variant="outlined"
                            fullWidth
                            size="small"
                            value={formatAbhaId(abhaData?.ABHANumber)}
                            disabled
                        />
                    </div>

                    {/* ABHA Address */}
                    <div className="col-md-6">
                        <TextField
                            label="ABHA Address"
                            variant="outlined"
                            fullWidth
                            size="small"
                            value={abhaData?.preferredAbhaAddress || ""}
                            disabled
                        />
                    </div>
                </div>

                <div className="row g-3 mt-1">
                    {/* Address */}
                    <div className="col-12">
                        <TextField
                            label="Address"
                            variant="outlined"
                            fullWidth
                            size="small"
                            multiline
                            rows={2}
                            value={
                                abhaData?.address && abhaData?.pincode
                                    ? `${abhaData.address} - ${abhaData.pincode}`
                                    : abhaData?.address || ""
                            }
                            disabled
                        />
                    </div>
                </div>
            </div>

            <Button
                variant="contained"
                fullWidth
                className="register-btn mt-3"
                onClick={onRegisterBeneficiary}
            >
                # Register Beneficiary
            </Button>

            <div className="para-ofadhar">
                <span>
                    <img src={Abhashiled} alt="Shield" />
                </span>
                <p>
                    Your ABHA details are secure and encrypted. You can now proceed to register the beneficiary.
                </p>
            </div>
        </div>
    );
};

export default Step4AbhaRegistered;